module.exports = [
	{
		"id": 1,
		"name": "Normal Man",
		"episodes": [
			20,
			93,
			109,
			137,
			163,
			174,
			194,
			232
		]
	},
	{
		"id": 2,
		"name": "Susan Strong",
		"episodes": [
			44,
			66,
			185,
			237,
			238,
			245,
			246,
			249,
			252
		]
	},
	{
		"id": 3,
		"name": "LSP",
		"episodes": [
			2,
			3,
			52,
			58,
			64,
			65,
			90,
			129,
			153,
			162,
			165,
			195,
			209,
			215,
			219,
			258,
			259,
			260,
			261
		]
	},
	{
		"id": 4,
		"name": "Grob Gob Glob Grod",
		"episodes": [
			93,
			120,
			157,
			181,
			194,
			232
		]
	},
	{
		"id": 5,
		"name": "Cosmic Owl",
		"episodes": [
			3,
			21,
			70,
			104,
			106,
			134,
			157,
			192
		]
	},
	{
		"id": 6,
		"name": "Fionna and Cake",
		"episodes": [
			61,
			112,
			115,
			165,
			234,
			264
		]
	},
	{
		"id": 7,
		"name": "BMO",
		"episodes": [
			42,
			49,
			80,
			92,
			95,
			107,
			121,
			124,
			132,
			137,
			143,
			148,
			173,
			176,
			190,
			191,
			204,
			213,
			214,
			216,
			219,
			243,
			245,
			246,
			248,
			252,
			253,
			254,
			263,
			268,
			271
		]
	},
	{
		"id": 8,
		"name": "Demon Blood Sword",
		"episodes": [
			77,
			144,
			145
		]
	},
	{
		"id": 9,
		"name": "Prismo",
		"episodes": [
			104,
			105,
			106,
			157,
			175,
			192,
			222
		]
	},
	{
		"id": 10,
		"name": "Peppermint Butler",
		"episodes": [
			43,
			125,
			171,
			173,
			198,
			211,
			244,
			273
		]
	},
	{
		"id": 11,
		"name": "Jermaine",
		"episodes": [
			34,
			172,
			189,
			262
		]
	},
	{
		"id": 12,
		"name": "Root Beer Guy",
		"episodes": [
			147,
			166,
			202
		]
	},
	{
		"id": 13,
		"name": "Guest Animator Episodes",
		"episodes": [
			119,
			123,
			163,
			193
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/minor-arcs.json
// module id = 147
// module chunks = 0